import React from "react";
import { styled } from "@mui/material/styles";
import MuiTooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

export const Tooltip = styled(({ className, ...props }: TooltipProps) => (
	<MuiTooltip
		placement="top-start"
		{...props}
		classes={{ popper: className }}
		arrow
	/>
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		border: 'none',
		backgroundColor: '#595959',
		padding: '8px 12px',
		fontSize: '12px',
		fontWeight: '500',
		lineHeight: '16px',
		color: '#F8F8F8',
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: '#595959',
	},
	// Offset
	[`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
		marginBottom: '7px',
	},
	[`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
		marginTop: '7px',
	},
	[`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]: {
		marginRight: '7px',
	},
	[`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]: {
		marginLeft: '7px',
	},
}));
